import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { ResponsivePie } from "@nivo/pie";

const MyResponsivePie = ({ data, isSmallScreen, pattern }) => (
  <ResponsivePie
    data={data}
    margin={{ top: 30, right: 60, bottom: 60, left: 60 }}
    innerRadius={0.5}
    padAngle={0.7}
    cornerRadius={3}
    activeOuterRadiusOffset={8}
    borderWidth={1}
    borderColor={{
      from: "color",
      modifiers: [["darker", 0.2]],
    }}
    arcLabel={(d) => `${d.value} Nos (${d.data.amount}  Rs)`}
    arcLinkLabel={(d) => `${d.id.substring(0, 20)}`}
    enableArcLinkLabels={!isSmallScreen}
    arcLinkLabelsSkipAngle={10}
    arcLinkLabelsTextColor="#333333"
    arcLinkLabelsThickness={2}
    arcLinkLabelsColor={{ from: "color" }}
    arcLabelsSkipAngle={10}
    arcLabelsTextColor={{
      from: "color",
      modifiers: [["darker", 2]],
    }}
    defs={[
      {
        id: "dots",
        type: "patternDots",
        background: "inherit",
        color: "rgba(255, 255, 255, 0.3)",
        size: 4,
        padding: 1,
        stagger: true,
      },
      {
        id: "lines",
        type: "patternLines",
        background: "inherit",
        color: "rgba(255, 255, 255, 0.3)",
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
      },
      {
        id: "square",
        type: "patternSquares",
        background: "inherit",
        color: "rgba(255, 255, 255, 0.3)",
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
      },
    ]}
    fill={[
      {
        match: "*",
        id: pattern,
      },
    ]}
    legends={[
      {
        anchor: "bottom",
        direction: "row",
        justify: false,
        translateX: 0,
        translateY: 56,
        itemsSpacing: 0,
        itemWidth: 150,
        itemHeight: 18,
        itemTextColor: "#999",
        itemDirection: "left-to-right",
        itemOpacity: 1,
        symbolSize: 18,
        symbolShape: "circle",
        effects: [
          {
            on: "hover",
            style: {
              itemTextColor: "#000",
            },
          },
        ],
      },
    ]}
  />
);

const TopSellingProducts = ({ time = "all" }) => {
  const statistics = useSelector((state) => state.statistics.item);
  // const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = false;
  const dataToday = statistics?.top_selling_product_today.map((item) => ({
    id: item.name,
    label: item.name.substring(0, 20),
    value: item.sales_count,
    amount: item.sales_amount,
  }));

  const dataThisWeek = statistics?.top_selling_product_this_week.map(
    (item) => ({
      id: item.name,
      label: item.name.substring(0, 20),
      value: item.sales_count,
      amount: item.sales_amount,
    })
  );

  const dataMonth = statistics?.top_selling_product_this_month.map((item) => ({
    id: item.name,
    label: item.name.substring(0, 20),
    value: item.sales_count,
    amount: item.sales_amount,
  }));
  const dataYear = statistics?.top_selling_product_this_year.map((item) => ({
    id: item.name,
    label: item.name.substring(0, 20),
    value: item.sales_count,
    amount: item.sales_amount,
  }));
  const dataAllTime = statistics?.top_selling_product_all_time.map((item) => ({
    id: item.name,
    label: item.name.substring(0, 20),
    value: item.sales_count,
    amount: item.sales_amount,
  }));

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Typography
        variant="h4"
        color="text.secondary"
        sx={{ textDecoration: "underline" }}
      >
        Top selling products
      </Typography>
      {time === "today" && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {(dataToday?.length ?? 0) > 0 ? (
              <MyResponsivePie
                data={dataToday}
                isSmallScreen={isSmallScreen}
                pattern="lines"
              />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            Today
          </Typography>
        </>
      )}

      {time === "week" && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {(dataThisWeek?.length ?? 0) > 0 ? (
              <MyResponsivePie
                data={dataThisWeek}
                isSmallScreen={isSmallScreen}
                pattern="lines"
              />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            This week
          </Typography>
        </>
      )}

      {time === "month" && (
        <>
          <Box
            sx={{
              height: 400,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {dataMonth?.length ? (
              <MyResponsivePie
                data={dataMonth}
                isSmallScreen={isSmallScreen}
                pattern="lines"
              />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            This month
          </Typography>
        </>
      )}

      {time === "year" && (
        <>
          <Box
            sx={{
              height: 400,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {(dataYear?.length ?? 0) > 0 ? (
              <MyResponsivePie
                data={dataYear}
                isSmallScreen={isSmallScreen}
                pattern="lines"
              />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            This Year
          </Typography>
        </>
      )}

      {time === "all" && (
        <>
          <Box
            sx={{
              height: 400,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {(dataAllTime?.length ?? 0) > 0 ? (
              <MyResponsivePie
                data={dataAllTime}
                isSmallScreen={isSmallScreen}
                pattern="lines"
              />
            ) : (
              "--"
            )}
          </Box>
          <Typography variant="h5" color="text.secondary" alignSelf="center">
            All time
          </Typography>
        </>
      )}
    </Box>
  );
};

export default TopSellingProducts;
